<div class="card" (contextmenu)="$event.preventDefault()">
  <div class="row">
    <div class="col-1"></div>
    <div class="col-10 header">
      <span class="header">Transferee/Buyer Questionnaire</span>
    </div>
    <div class="col-1">
      @if (this.sharedService.kiosk_mode === true) {
      <button
        type="button"
        class="btn-close float-end"
        data-bs-dismiss="modal"
        aria-label="Close"
        style="margin-right: 10px; margin-top: 10px"
        (click)="escapeKioskMode()"
      ></button>
      }
    </div>
    <!-- Wrap divider in a constrained div -->
    <div style="width: 98%; margin-left: 1%; margin-right: 1%">
      <hr class="divider" />
    </div>
  </div>
  <!--body-->
  <div class="row" style="width: 100%">
    <!-------------------------------------Left Side------------------------------------------>
    <div
      id="scrollable-container"
      class="col-8 scrollable-column no-horizontal-scroll"
      style="margin-left: 10px; padding-left: 0px; padding-right: 0px"
    >
      <form
        [formGroup]="buyer_4473_form"
        (ngSubmit)="completeQuestionnaireClick()"
        autocomplete="off"
      >
        <div class="row sticky-top">
          <p style="margin-left: 10px">
            Fields marked with an asterisk (<span style="color: red">*</span>)
            are required.
          </p>
        </div>
        <!-------------------------------------Section 2------------------------------------>
        @if (form_section === 2) {
        <div>
          <!---------------------9. Transferee’s/Buyer’s Full Name-------------------------->
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label">9. Transferee’s/Buyer’s Full Name</span>
              <button
                class="round-button btn btn-sm"
                tooltip="Click for instructions"
                placement="right"
                (click)="openInstructions('9')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
              <p>
                (If legal name contains an initial only, record the initial
                followed by “IO” in quotes. If no middle initial or name, record
                “NMN”.)
              </p>
            </div>
          </div>
          <!--First Name-->
          <div class="row my-1">
            <div class="col-sm-4 first-name-scan-control">
              <button
                type="button"
                class="btn btn-primary btn-sm id_button"
                (click)="scanDriversLicense()"
                tooltip="Scan Drivers License"
                [disabled]="scan_drivers_license"
              >
                <i class="fa-solid fa-address-card" style="color: white"></i>
              </button>
              <label for="name_first"
                ><span style="color: red">*</span>First Name:</label
              >
            </div>
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="name_first"
                autocomplete="new-password"
              />
            </div>
          </div>
          <!--Middle Name-->
          <div class="row my-1">
            <label
              for="name_middle"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Middle Name:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="name_middle"
                autocomplete="new-password"
              />
            </div>
          </div>
          <!--Last Name-->
          <div class="row my-1">
            <label
              for="name_last"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Last Name:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="name_last"
                autocomplete="new-password"
              />
            </div>
          </div>
          <!-------------------10. Current State of Residence and Address---------------->
          <br />
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label"
                >10. Current State of Residence and Address</span
              >
              <button
                class="round-button btn btn-sm"
                tooltip="Click for instructions"
                placement="right"
                (click)="openInstructions('10')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
              <p>
                (U.S. postal abbreviations are acceptable. Cannot be a post
                office box.)
              </p>
            </div>
          </div>
          <!--Number and Street Address-->
          <div class="row my-1">
            <label
              for="address_street"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Number and Street
              Address:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="address_street"
                autocomplete="new-password"
              />
            </div>
          </div>
          <!--Zip Code-->
          <div class="row my-1">
            <label
              for="address_zip_code"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Zip Code:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="address_zip_code"
                autocomplete="new-password"
              />
            </div>
          </div>
          <!--City-->
          <div class="row my-1">
            <label
              for="address_city"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>City:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="address_city"
                autocomplete="new-password"
              />
            </div>
          </div>
          <!--Reside in City Limits-->
          <div class="row my-1">
            <label
              for="reside_in_city_limits"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Reside in City Limits?</label
            >
            <div class="col-sm-8" style="display: flex; align-items: center; gap: 15px;">
              <div>
                <input
                  type="radio"
                  id="city_limits_yes"
                  name="reside_in_city_limits"
                  value="yes"
                  formControlName="reside_in_city_limits"
                />
                <label for="city_limits_yes" style="margin-left: 5px;">Yes</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="city_limits_no"
                  name="reside_in_city_limits"
                  value="no"
                  formControlName="reside_in_city_limits"
                />
                <label for="city_limits_no" style="margin-left: 5px;">No</label>
              </div>
              <div>
                <input
                  type="radio"
                  id="city_limits_unknown"
                  name="reside_in_city_limits"
                  value="unknown"
                  formControlName="reside_in_city_limits"
                />
                <label for="city_limits_unknown" style="margin-left: 5px;">Unknown</label>
              </div>
            </div>
          </div>
          <!--State-->
          <div class="row my-1">
            <label
              for="address_state"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>State:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="address_state"
                autocomplete="new-password"
              />
            </div>
          </div>
          <!--County-->
          <div class="row my-1">
            <label
              for="address_county"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>County:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                #address_county
                type="text"
                class="form-control text-uppercase input"
                formControlName="address_county"
                autocomplete="new-password"
              />
            </div>
          </div>
          <!-------------------------- 11. Place of Birth ------------------------------->
          <br />
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label">11. Place of Birth</span>
            </div>
          </div>
          <!--Birth County-->
          <div class="row my-1">
            <label
              for="birth_country"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Country:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <ng-select
                [items]="countries"
                [multiple]="false"
                [closeOnSelect]="true"
                appendTo="body"
                class="form-control text-uppercase input"
                formControlName="birth_country"
                style="display: inline-block"
              ></ng-select>
            </div>
          </div>
          <!--Birth State-->
          @if ( buyer_4473_form.get('birth_country').value === 'UNITED STATES' )
          {
          <div class="row my-1">
            <label
              for="birth_state"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>State:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <ng-select
                [items]="states"
                [multiple]="false"
                [closeOnSelect]="true"
                appendTo="body"
                class="form-control text-uppercase input"
                formControlName="birth_state"
                style="display: inline-block"
              ></ng-select>
            </div>
          </div>
          }
          <!--Birth City-->
          @if ( buyer_4473_form.get('birth_country').value === 'UNITED STATES' )
          {
          <div class="row my-1">
            <label
              for="birth_city"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>City:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="birth_city"
              />
            </div>
          </div>
          }
          <!--Person Features-->
          <br />
          <!----------------------- 12. Height  13. Weight----------------------------->
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label">12. Height </span
              ><span class="label" style="margin-left: 300px"> 13. Weight</span>
            </div>
          </div>
          <div class="row my-1">
            <label
              for="height_feet"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Feet:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                style="display: inline-block; width: 90px"
                formControlName="height_feet"
                (keypress)="numbersOnly($event)"
                maxlength="1"
              />
              <span
                style="margin-left: 20px; margin-right: 10px; margin-top: 5px"
                ><span style="color: red">*</span>Inches:</span
              >
              <input
                type="text"
                class="form-control text-uppercase input"
                style="display: inline-block; width: 90px"
                formControlName="height_inches"
                (keypress)="numbersOnly($event)"
                maxlength="2"
              />
              <span
                style="margin-left: 20px; margin-right: 10px; margin-top: 5px"
                ><span style="color: red">*</span> Weight (lbs):</span
              >
              <input
                type="text"
                class="form-control text-uppercase input"
                style="display: inline-block; width: 90px"
                formControlName="weight"
                (keypress)="numbersOnly($event)"
                maxlength="3"
              />
            </div>
          </div>
          <!------------------------------- 14. Sex ----------------------------------->
          <br />
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label"> 14. Sex</span>
              <button
                class="round-button btn btn-sm"
                tooltip="Click for instructions"
                placement="right"
                (click)="openInstructions('14')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </div>
          </div>
          <div class="row my-1">
            <label
              for="sex"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Sex:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <ng-select
                [items]="sex_options"
                [multiple]="false"
                [closeOnSelect]="true"
                appendTo="body"
                class="form-control text-uppercase input"
                formControlName="sex"
                style="display: inline-block; width: 200px"
              ></ng-select>
            </div>
          </div>
          <!--------------------------- 15. Birth Date -------------------------------->
          <br />
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label"> 15. Birth Date</span>
            </div>
          </div>
          <div class="row my-1">
            <label
              for="birth_month"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Month:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                style="display: inline-block; width: 90px"
                formControlName="birth_month"
                maxlength="2"
              />
              <span
                style="margin-left: 20px; margin-right: 10px; margin-top: 5px"
                ><span style="color: red">*</span>Day:</span
              >
              <input
                type="text"
                class="form-control text-uppercase input"
                style="display: inline-block; width: 90px"
                formControlName="birth_day"
                maxlength="2"
              />
              <span
                style="margin-left: 20px; margin-right: 10px; margin-top: 5px"
                ><span style="color: red">*</span>Year:</span
              >
              <input
                type="text"
                class="form-control text-uppercase input"
                style="display: inline-block; width: 90px"
                formControlName="birth_year"
                maxlength="4"
              />
            </div>
          </div>
          <br />
          <!------------------------- 16. Social Security ----------------------------->
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label"> 16. Social Security</span>
            </div>
          </div>
          <div class="row my-1">
            <label
              for="social_security"
              class="col-sm-4 col-form-label col-form-label text-end"
              >Social Security:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                style="width: 200px"
                class="form-control text-uppercase input"
                formControlName="social_security"
                placeholder="_ _ _-_ _-_ _ _ _"
                pattern="^[0-9]{3}-[0-9]{2}-[0-9]{4}$"
                ssnMask
              /><span style="margin-top: 5px; color: blue"
                >(optional, but will help prevent misidentification)</span
              >
            </div>
          </div>
          <br />
          <!-------------------------------- 17. UPIN --------------------------------->
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label">17. UPIN</span>
              <button
                class="round-button btn btn-sm"
                tooltip="Click for instructions"
                placement="right"
                (click)="openInstructions('17')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
              <p>
                Unique Personal Identification Number (UPIN) or Appeals
                Management Database Identification (AMD ID) (if applicable).
              </p>
            </div>
          </div>
          <div class="row my-1">
            <label
              for="upin"
              class="col-sm-4 col-form-label col-form-label text-end"
              >UPIN:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <input
                type="text"
                class="form-control text-uppercase input"
                formControlName="upin"
              />
            </div>
          </div>
          <!----------------------------- 18a. Ethnicity ------------------------------->
          <br />
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label"> 18a. Ethnicity</span>
              <button
                class="round-button btn btn-sm"
                tooltip="Click for instructions"
                placement="right"
                (click)="openInstructions('18a')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </div>
          </div>
          <div class="row my-1">
            <label
              for="ethnicity"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Ethnicity:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <ng-select
                [items]="ethnicity_options"
                [multiple]="false"
                [closeOnSelect]="true"
                appendTo="body"
                class="form-control text-uppercase input"
                formControlName="ethnicity"
                style="display: inline-block"
              ></ng-select>
            </div>
          </div>
          <br />
          <!------------------------------- 18b. Race ---------------------------------->
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label"> 18b. Race</span>
              <button
                class="round-button btn btn-sm"
                tooltip="Click for instructions"
                placement="right"
                (click)="openInstructions('18a')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </div>
          </div>
          <div class="row my-1">
            <div class="col-4"></div>
            <div class="col-8">
              <span
                >(Select one or more race in 18.b. Both 18.a. and 18.b. must be
                answered.)</span
              >
            </div>
          </div>
          <div class="row my-1">
            <label
              for="race"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Race:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <ng-select
                [items]="race_options"
                [multiple]="true"
                [closeOnSelect]="true"
                appendTo="body"
                class="form-control text-uppercase input"
                formControlName="race"
                style="display: inline-block"
              ></ng-select>
            </div>
          </div>
          <br />
          <!--------------------------19. Country of Citizenship:----------------------->
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label"> 19. Country of Citizenship</span>
            </div>
          </div>
          <div class="row my-1">
            <div class="col-4"></div>
            <div class="col-8">
              <span
                >(Check/List more than one, if applicable. Nationals of the
                United States may check U.S.A.)</span
              >
            </div>
          </div>
          <div class="row my-1">
            <label
              for="citizenship"
              class="col-sm-4 col-form-label col-form-label text-end"
              ><span style="color: red">*</span>Country of Citizenship:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <ng-select
                [items]="countries"
                [multiple]="true"
                [closeOnSelect]="true"
                appendTo="body"
                class="form-control text-uppercase input"
                formControlName="citizenship"
                style="display: inline-block"
              ></ng-select>
            </div>
          </div>
          <br />
          <!-----------------------20. Alien or Admission Number:---------------------->
          <div class="row" style="margin: auto">
            <div class="col-4"></div>
            <div class="col-8">
              <span class="label">Alien or Admission Number</span>
              <button
                class="round-button btn btn-sm"
                tooltip="Click for instructions"
                placement="right"
                (click)="openInstructions('20')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
              <p>
                If you are an alien, record your U.S.-issued alien or admission
                number (AR#, USCIS#, or I94#)
              </p>
            </div>
          </div>
          <div class="row my-1">
            <label
              for="alien_prefix"
              class="col-sm-4 col-form-label col-form-label text-end"
              >20. Alien or Admission Number:</label
            >
            <div class="col-sm-8" style="display: inline-flex">
              <ng-select
                [items]="alien_number_prefixes"
                [multiple]="false"
                [closeOnSelect]="true"
                appendTo="body"
                class="form-control text-uppercase input"
                formControlName="alien_prefix"
                style="display: inline-block; width: 100px"
              ></ng-select>
              <input
                type="text"
                class="form-control text-uppercase input"
                style="display: inline-block; width: 200px; margin-left:10px"
                formControlName="alien_number"
              />
            </div>
          </div>
          <br />
        </div>
        }
        <!-------------------------------------Section 3------------------------------------>
        @if (form_section === 3) {
        <div style="margin-left: 10px">
          <table class="table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Manufacturer and Importer</th>
                <th scope="col">Model</th>
                <th scope="col">Serial Number</th>
                <th scope="col">Type</th>
                <th scope="col">Caliber or Gauge</th>
                <th scope="col">Pawn Redemption</th>
              </tr>
            </thead>
            <tbody>
              @for ( firearm of selected_firearms_for_dispo; track firearm; let
              i = $index) {
              <tr>
                <td scope="row">{{ i + 1 }}</td>
                <td>{{ firearm.a_manufacture }}</td>
                <td>{{ firearm.a_model }}</td>
                <td>{{ firearm.a_serial_number }}</td>
                <td>{{ firearm.a_firearm_type }}</td>
                <td>{{ firearm.a_caliber_gauge }}</td>
                <td>{{ "No" }}</td>
              </tr>
              }
            </tbody>
          </table>
          <!---------------------------------Question 21a----------------------------------->
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.a.</span> Are you the actual
              transferee/buyer of the firearm(s) listed on this form and any
              continuation sheet(s) (ATF Form 5300.9A)?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21a')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <p class="bold">
              <span style="color: red">Warning:</span> You are not the actual
              transferee/buyer if you are acquiring the firearm(s) on behalf of
              another person. If you are not the actual transferee/buyer, the
              licensee cannot transfer the firearm(s) to you.
            </p>
            <p>
              Exception: If you are only picking up a repaired firearm(s) for
              another person, you are not required to answer 21.a. and may
              proceed to question 21.b.
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qa_option1"
                    name="question_a"
                    [value]="true"
                    formControlName="question_a"
                  />
                  <label class="bold radio_label" for="qa_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qa_option2"
                    name="question_a"
                    [value]="false"
                    formControlName="question_a"
                  />
                  <label class="bold radio_label" for="qa_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21b----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.b.</span> Are you under indictment or
              information in any court for a <span class="bold">felony</span>,
              or any other crime, for which the judge could imprison you for
              more than one year, or are you a current member of the military
              who has been charged with violation(s) of the Uniform Code of
              Military Justice and whose charge(s) have been referred to a
              general court-martial?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21b')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qb_option1"
                    name="question_b"
                    [value]="true"
                    formControlName="question_b"
                  />
                  <label class="bold radio_label" for="qb_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qb_option2"
                    name="question_b"
                    [value]="false"
                    formControlName="question_b"
                  />
                  <label class="bold radio_label" for="qb_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21c----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.c.</span> Have you ever been convicted in
              any court, including a military court, of a
              <span class="bold">felony</span>, or any other crime for which the
              judge could have imprisoned you for more than one year, even if
              you received a shorter sentence including probation?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21b')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qc_option1"
                    name="question_c"
                    [value]="true"
                    formControlName="question_c"
                  />
                  <label class="bold radio_label" for="qc_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qc_option2"
                    name="question_c"
                    [value]="false"
                    formControlName="question_c"
                  />
                  <label class="bold radio_label" for="qc_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21d----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.d.</span> Are you a fugitive from justice?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21b')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qd_option1"
                    name="question_d"
                    [value]="true"
                    formControlName="question_d"
                  />
                  <label class="bold radio_label" for="qd_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qd_option2"
                    name="question_d"
                    [value]="false"
                    formControlName="question_d"
                  />
                  <label class="bold radio_label" for="qd_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21e----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.e.</span> Are you an unlawful user of, or
              addicted to, marijuana or any depressant, stimulant, narcotic
              drug, or any other controlled substance?
            </p>
            <p>
              <span class="bold" style="color: red">Warning:</span> The use or
              possession of marijuana remains unlawful under Federal law
              regardless of whether it has been legalized or decriminalized for
              medicinal or recreational purposes in the state where you reside.
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21b')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qe_option1"
                    name="question_e"
                    [value]="true"
                    formControlName="question_e"
                  />
                  <label class="bold radio_label" for="qe_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qe_option2"
                    name="question_e"
                    [value]="false"
                    formControlName="question_e"
                  />
                  <label class="bold radio_label" for="qe_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21f----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.f.</span> Have you ever been adjudicated as
              a mental defective OR have you ever been committed to a mental
              institution?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21f')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qf_option1"
                    name="question_f"
                    [value]="true"
                    formControlName="question_f"
                  />
                  <label class="bold radio_label" for="qf_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qf_option2"
                    name="question_f"
                    [value]="false"
                    formControlName="question_f"
                  />
                  <label class="bold radio_label" for="qf_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21g----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.g.</span> Have you ever been discharged
              from the Armed Forces under dishonorable conditions?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21b')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qg_option1"
                    name="question_g"
                    [value]="true"
                    formControlName="question_g"
                  />
                  <label class="bold radio_label" for="qg_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qg_option2"
                    name="question_g"
                    [value]="false"
                    formControlName="question_g"
                  />
                  <label class="bold radio_label" for="qg_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21h----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.h.</span> Are you subject to a court order,
              including a Military Protection Order issued by a military judge
              or magistrate, restraining you from harassing, stalking, or
              threatening your child or an intimate partner or child of such
              partner?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21h')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qh_option1"
                    name="question_h"
                    [value]="true"
                    formControlName="question_h"
                  />
                  <label class="bold radio_label" for="qh_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qh_option2"
                    name="question_h"
                    [value]="false"
                    formControlName="question_h"
                  />
                  <label class="bold radio_label" for="qh_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21i----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.i.</span> Have you ever been convicted in
              any court of a misdemeanor crime of domestic violence, or are you
              or have you ever been a member of the military and been convicted
              of a crime that included, as an element, the use of force against
              a person as identified in the instructions?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21i')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qi_option1"
                    name="question_i"
                    [value]="true"
                    formControlName="question_i"
                  />
                  <label class="bold radio_label" for="qi_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qi_option2"
                    name="question_i"
                    [value]="false"
                    formControlName="question_i"
                  />
                  <label class="bold radio_label" for="qi_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21j----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.j.</span> Have you ever renounced your
              United States citizenship?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21b')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qj_option1"
                    name="question_j"
                    [value]="true"
                    formControlName="question_j"
                  />
                  <label class="bold radio_label" for="qj_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qj_option2"
                    name="question_j"
                    [value]="false"
                    formControlName="question_j"
                  />
                  <label class="bold radio_label" for="qj_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21k----------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.k.</span>Are you an alien
              <span class="bold">illegally</span> or
              <span class="bold">unlawfully</span> in the United States?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21b')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qk_option1"
                    name="question_k"
                    [value]="true"
                    formControlName="question_k"
                  />
                  <label class="bold radio_label" for="qk_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="qk_option2"
                    name="question_k"
                    [value]="false"
                    formControlName="question_k"
                  />
                  <label class="bold radio_label" for="qk_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21l1---------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.l1.</span>Are you an alien who has been
              addmitted to the United States under a nonimmigrant visa?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21l')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="ql1_option1"
                    name="question_l1"
                    [value]="true"
                    formControlName="question_l1"
                  />
                  <label class="bold radio_label" for="ql1_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="ql1_option2"
                    name="question_l1"
                    [value]="false"
                    formControlName="question_l1"
                  />
                  <label class="bold radio_label" for="ql1_option2">No</label>
                </div>
              </div>
            </div>
          </div>
          <!---------------------------------Question 21l2---------------------------------->
          <br /><br />
          <div>
            <p>
              <span style="color: red">*</span
              ><span class="bold">21.l2.</span>If you are such an alien do you
              fall within any of the exceptions stated in the instructions?
              <button
                class="round-button btn btn-sm"
                placement="right"
                (click)="openInstructions('21l')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </p>
            <p style="color: red">
              (U.S. citizens/nationals leave 21.l.2. blank)
            </p>
            <div>
              <div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="ql2_option1"
                    name="question_l2"
                    [value]="true"
                    formControlName="question_l2"
                  />
                  <label class="bold radio_label" for="ql2_option1">Yes</label>
                </div>
                <div class="radio_div">
                  <input
                    type="radio"
                    id="ql2_option2"
                    name="question_l2"
                    [value]="false"
                    formControlName="question_l2"
                  />
                  <label class="bold radio_label" for="ql2_option2">No</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        <!-----------------------------Buyer Certification-------------------------------->
        @if (form_section === 4) {
        <div style="margin-left: 10px">
          <br />
          <p class="bold">
            I certify that my answers in Section B are true, correct, and
            complete. I have read and understand the Notices, Instructions, and
            Definitions on ATF Form 4473. I understand that answering “yes” to
            question 21.a. if I am not the actual transferee/buyer is a crime
            punishable as a felony under Federal law, and may also violate State
            and/or local law. I understand that a person who answers “yes” to
            any of the questions 21.b. through 21.k. is prohibited from
            receiving or possessing a firearm. I understand that a person who
            answers “yes” to question 21.l.1. is prohibited from receiving or
            possessing a firearm, unless the person answers “yes” to question
            21.l.2. and provides the documentation required in 26.d. I also
            understand that making any false oral or written statement, or
            exhibiting any false or misrepresented identification with respect
            to this transaction, is a crime punishable as a felony under Federal
            law, and may also violate State and/or local law. I further
            understand that the repetitive purchase of firearms for the purpose
            of resale for livelihood and profit without a Federal firearms
            license is a violation of Federal law.
          </p>
          <br />
          <div class="row">
            <div class="col-12">
              <input
                type="checkbox"
                id="option1"
                name="option1"
                [value]="false"
                formControlName="transferee_cert"
              />
              <label for="option1" style="margin-left: 10px"
                >I agree with and certify the above statement</label
              >
              <button
                class="round-button btn btn-sm"
                tooltip="Click for instructions"
                placement="right"
                (click)="openInstructions('9')"
              >
                <i class="fa-solid fa-question"></i>
              </button>
            </div>
          </div>
        </div>
        }
        <!------------------------------------Footer-------------------------------------->
        <div class="row" style="margin-top: 10px; margin-bottom: 10px">
          <div class="col">
            @if (form_section > 2) {
            <button
              type="button"
              class="btn btn-secondary float-start"
              style="width: 200px; margin-left: 10px"
              (click)="previousSectionClick()"
            >
              Previous
            </button>
            } @if (form_section < 4) {
            <button
              type="button"
              class="btn btn-primary float-end"
              style="width: 200px; margin-right: 10px"
              (click)="nextSectionClick()"
              [disabled]="
                (form_section === 2 &&
                  (this.buyer_4473_form.get('name_first').value === null ||
                    this.buyer_4473_form.get('name_middle').value === null ||
                    this.buyer_4473_form.get('name_last').value === null ||
                    this.buyer_4473_form.get('address_street').value === null ||
                    this.buyer_4473_form.get('address_city').value === null ||
                    this.buyer_4473_form.get('address_state').value === null ||
                    this.buyer_4473_form.get('address_zip_code').value === null ||
                    this.buyer_4473_form.get('address_county').value === null ||
                    this.buyer_4473_form.get('birth_country').value === null ||
                    this.buyer_4473_form.get('height_feet').value === null ||
                    this.buyer_4473_form.get('height_inches').value === null ||
                    this.buyer_4473_form.get('weight').value === null ||
                    this.buyer_4473_form.get('sex').value === null ||
                    this.buyer_4473_form.get('birth_month').value === null ||
                    this.buyer_4473_form.get('birth_day').value === null ||
                    this.buyer_4473_form.get('birth_year').value === null ||
                    this.buyer_4473_form.get('ethnicity').value === null ||
                    this.buyer_4473_form.get('race').value === null ||
                    this.buyer_4473_form.get('citizenship').value === null)) ||
                (form_section === 3 &&
                  (this.buyer_4473_form.get('question_a').value === null ||
                    this.buyer_4473_form.get('question_b').value === null ||
                    this.buyer_4473_form.get('question_c').value === null ||
                    this.buyer_4473_form.get('question_d').value === null ||
                    this.buyer_4473_form.get('question_e').value === null ||
                    this.buyer_4473_form.get('question_f').value === null ||
                    this.buyer_4473_form.get('question_g').value === null ||
                    this.buyer_4473_form.get('question_h').value === null ||
                    this.buyer_4473_form.get('question_i').value === null ||
                    this.buyer_4473_form.get('question_j').value === null ||
                    this.buyer_4473_form.get('question_k').value === null ||
                    this.buyer_4473_form.get('question_l1').value === null))
              "
            >
              Next
            </button>
            } @if (form_section === 4) {
            <button
              type="button"
              class="btn btn-primary float-end"
              style="width: 200px; margin-right: 10px"
              (click)="openDigitalSignatureModal()"
              [disabled]="!buyer_4473_form.get('transferee_cert').value"
            >
              Sign Form
            </button>
            } 
            <!-- @if (form_section === 2) {
            <button
              type="button"
              class="btn btn-primary float-end"
              style="width: 200px; margin-right: 10px"
              (click)="patchFields2()"
            >
              populate Fields
            </button>
            } 
            @if (form_section === 3) {
            <button
              type="button"
              class="btn btn-primary float-end"
              style="width: 200px; margin-right: 10px"
              (click)="patchFields2()"
            >
              populate Fields
            </button>
            } -->
            <!--   [disabled]="!this.buyer_4473_form.valid && form_section === 3" -->
          </div>
        </div>
      </form>
    </div>
    <!-------------------------------------Right Side------------------------------------------>
    <div class="col-4" style="min-height: 85vh; width: 32%">
      <div class="row" style="display: block">
        <span style="font-weight: bold">
          {{ this.selected_instruction.title }}</span
        >
        @if (this.selected_instruction.title) {
        <button
          type="button"
          class="btn-close float-end"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeInstructions()"
        ></button>
        }
      </div>
      <div class="row">
        <div
          class="scrollable-column no-horizontal-scroll"
          style="height: 700px"
          [innerHTML]="this.selected_instruction.body"
        ></div>
      </div>
      <!-- (click)="cancelFormClick()" -->
      <div class="row">
        <div class="container">
             
          <button
            type="button"
            class="btn btn-secondary"
            (click)="resetFormClick()"
            style="width: 150px"
          >
            Reset Form
          </button>

          <button
            type="button"
            class="btn btn-danger float-end"
            (click)="cancelFormClick()"
            style="width: 150px"
          >
            Cancel Form
          </button>

        </div>
      </div>
    </div>
  </div>
</div>
